import { useMaestriaContent } from "@/shared/i18n/LocaleContext";
import styles from "./Footer.module.css";

export function Footer() {
  const { brand, footer } = useMaestriaContent();

  return (
    <footer className={styles.footer}>
      <div className={`maestria-container ${styles.inner}`}>
        <img
          src={brand.logo}
          alt={brand.name}
          width={180}
          height={42}
        />
        <p className={styles.copy}>{footer.copyright}</p>
        <a
          className={styles.privacy}
          href={footer.privacy.href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {footer.privacy.label}
        </a>
        <button
          className={styles.privacy}
          type="button"
          onClick={() => window.dispatchEvent(new Event("autouprivacyopen"))}
        >
          {footer.preferences ?? "Preferencias de privacidade"}
        </button>
      </div>
    </footer>
  );
}
